import { useCallback } from 'react'
import { useUrlState } from './useUrlState'

export interface ArticleListFilters {
  search: string
  startDate: string
  endDate: string
  page: number
}

export function useArticleFilters() {
  const defaultFilters: ArticleListFilters = {
    search: '',
    startDate: '',
    endDate: '',
    page: 1,
  }

  const { state, updateState } = useUrlState<ArticleListFilters>(defaultFilters, {
    search: {
      serialize: (value) => (value && value.trim() ? value.trim() : undefined),
      deserialize: (value) => value || '',
    },
    startDate: {
      serialize: (value) => (value ? value : undefined),
      deserialize: (value) => value || '',
    },
    endDate: {
      serialize: (value) => (value ? value : undefined),
      deserialize: (value) => value || '',
    },
    page: {
      serialize: (value) => (value > 1 ? String(value) : undefined),
      deserialize: (value) => (value ? parseInt(value, 10) : 1),
    },
  })

  const updateFilterAndResetPage = useCallback(
    (updates: Partial<ArticleListFilters>) => {
      updateState({ ...updates, page: 1 })
    },
    [updateState],
  )

  const handlePageChange = useCallback(
    (newPage: number) => {
      updateState({ page: newPage })
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    [updateState],
  )

  return {
    filters: state,
    updateFilterAndResetPage,
    handlePageChange,
  }
}
